__turbopack_context__.v({
  "container": "KVHrCq_container",
  "header": "KVHrCq_header",
  "item": "KVHrCq_item",
  "list": "KVHrCq_list",
  "name": "KVHrCq_name",
  "price": "KVHrCq_price",
  "prop": "KVHrCq_prop",
  "props": "KVHrCq_props",
  "selectButton": "KVHrCq_selectButton",
  "tax": "KVHrCq_tax",
});
